/**
 * Created by wajidafaneh on 29/06/2016.
 */
(function (angular, moment, TeamScheduleAPI) {

    angular
        .module('harriApp')
        .controller('TSViewEmployeeScheduleController', ["$scope", "$stateParams", "$location", "$modal", "TSUsersService", function ($scope, $stateParams, $location, $modal, TSUsersService) {
            //Config
            var MINUTE = 60 * 1000;
            var MIN_PERIOD = 15 * MINUTE;
            var DAY_START = new Date().getTime();

            var employeeId = $stateParams.employee_id;
            var brandId = $stateParams.brand_id;
            $scope.scheduleDate = $stateParams.date ? moment($stateParams.date) : moment();

            $scope.isLoadingScheduleData = false;
            $scope.scheduleData = [];


            //init employee data
            $scope.employeeData = {};

            //Load user data
            TSUsersService.loadUsers(brandId, [employeeId]);

            //bind any new loaded data
            TSUsersService.onUsersLoaded(function (users) {
                $scope.employeeData = users[0];

                setTimeout(function () {
                    $scope.$digest();
                });
            });

            //Move the schedule handle
            $scope.prevDay = function () {
                $scope.scheduleDate.subtract(1, 'd');
                $location.search('date', $scope.scheduleDate.format('YYYY-MM-DD'));
                loadScheduleData();
            };

            $scope.nextDay = function () {
                $scope.scheduleDate.add(1, 'd');
                $location.search('date', $scope.scheduleDate.format('YYYY-MM-DD'));
                loadScheduleData();
            };


            //Format data to person view
            var formatPersonView = function (data) {

                var dataList = [];

                data.forEach(function (schedule) {
                    schedule.roles.forEach(function (role) {
                        role.role_days.forEach(function (roleDay) {
                            roleDay.assignees.forEach(function (assignee) {
                                assignee.assignee_shifts.forEach(function (assignee_shift) {

                                    var newDataListObj = {};
                                    newDataListObj.start_time = assignee_shift.start_time;
                                    newDataListObj.end_time = assignee_shift.end_time;
                                    newDataListObj.assignee_id = assignee.id;
                                    newDataListObj.clone = assignee_shift.clone;
                                    newDataListObj.showPosition = true;
                                    newDataListObj.is_edited = assignee_shift.is_edited;
                                    newDataListObj.offset = parseInt((newDataListObj.start - DAY_START) / MIN_PERIOD);
                                    newDataListObj.size = parseInt((newDataListObj.end - newDataListObj.start) / MIN_PERIOD);
                                    newDataListObj.status = assignee_shift.status;
                                    newDataListObj.weight = assignee_shift.weight;
                                    newDataListObj.user_id = assignee.user_id;
                                    newDataListObj.role = role;
                                    newDataListObj.hours = moment(assignee_shift.end_time).diff(assignee_shift.start_time, 'hours');
                                    newDataListObj.unassigned = assignee.user_id ? false : true;
                                    newDataListObj.position = role.position;
                                    newDataListObj.shifts = 1;
                                    newDataListObj.schedule_id = schedule.id;
                                    newDataListObj.brand_id = schedule.brand_id;
                                    newDataListObj.id = assignee_shift.id;

                                    dataList.push(newDataListObj);
                                });
                            });
                        });
                    });
                });

                return dataList;
            };

            var handleScheduleErrors = function (err) {
                if (err && err.data && err.data.status === 'SCHEDULE_LOCKED') {
                    HNotifications.show({
                        title: $filter("translate")("Locked Schedule"),
                        desc: $filter("translate")("Schedule is locked, you won't be to make any changes"),
                        icon: "fa-lock"
                    });
                    $scope.scheduleLockStatus = ScheduleDataServiceV2.lockStatus = 'LOCKED';
                    $scope.$digest();
                } else if (err?.data?.status === 'SHIFTS_CREATION_COUNT_EXCEEDS_MAXIMUM_LIMIT') {
                    hAlert({
                        title: $filter("translate")("Error") + '!',
                        text: $filter("translate")("Unable to add this shift. It results in too many shifts on the schedule."),
                        button: {
                            text: $filter("translate")("OK")
                        }
                    });
                } else {
                    console.error(err);
                    hAlert("Error", "Something went wrong");
                }
            };

            $scope.showManageShiftModal = function (shift) {

                $('body').addClass('is-manage-shift-modal-open');

                $modal({
                    controller: 'TSEditShiftController',
                    templateUrl: '../modules/team_schedule/employer/shifts/views/edit_shift_modal.html',
                    show: true,
                    backdrop: 'static',
                    resolve: {
                        modalData: function () {
                            return {
                                mode: 'EDIT',
                                schedule_id: shift.schedule_id,
                                day: shift.day,
                                shift: shift,
                                user_id: shift.user_id,
                                assigneeId: shift.assignee_id,
                                position_code: shift.position.code,
                                role_id: shift.role.id,
                                brand_id: shift.brand_id
                            };
                        },
                        onSave: function () {
                            return function (res, action, publish) {
                                if (publish) {
                                    $scope.isLoadingScheduleData = true;

                                    var shiftIds = [];

                                    for (var i in res.roles) {
                                        var roles = res.roles[i];

                                        for (var j in roles.role_days) {
                                            var roleDay = roles.role_days[j];

                                            for (var k in roleDay.assignees) {

                                                for (var l in roleDay.assignees[k].assignee_shifts) {
                                                    var shiftId = roleDay.assignees[k].assignee_shifts[l].id;
                                                    shiftIds.push(shiftId);
                                                }
                                            }
                                        }
                                    }

                                    var payload = {
                                        shift_ids: shiftIds
                                    };

                                    TeamScheduleAPI.publishSchedule(brandId, shift.schedule_id, payload)
                                        .then(function (data) {
                                            lockScheduleOnPublish()
                                                .then(function () {
                                                    init();
                                                });
                                        });
                                }
                            }
                        },
                        onDelete: function () {
                            return function () {
                                init();
                            }
                        },
                        onStart: function () {

                        },
                        onError: function () {
                            return function (err) {
                                handleScheduleErrors(err);
                            }
                        },
                        onPublish: function () {
                            return function (shift, action) {
                                $scope.isLoadingScheduleData = true;

                                var payload = {
                                    shift_ids: [shift.id]
                                };

                                TeamScheduleAPI.publishSchedule(brandId, shift.schedule_id, payload)
                                    .then(function (data) {
                                        lockScheduleOnPublish()
                                            .then(function () {
                                                init();
                                            });
                                    });
                            }
                        }
                    }
                });
            };


            //Load the schedule data
            var loadScheduleData = function () {

                $scope.isLoadingScheduleData = true;

                TeamScheduleV2API.getEmployeeBrandSchedule(brandId, [$scope.scheduleDate.format('MMM D, YYYY')], employeeId)
                    .then(function (res) {
                        $scope.scheduleData = formatPersonView(res);
                        $scope.isLoadingScheduleData = false;

                        if (res && res[0]) {
                            $scope.scheduleLockStatus = ScheduleDataServiceV2.lockStatus = res[0].lock_status;
                        }

                        $scope.$digest();
                    });
            };

            var lockScheduleOnPublish = function () {
                var deferred = $q.defer();

                if ($scope.scheduleLockStatus === "UNLOCKED") {
                    TeamScheduleV2API.changeBrandScheduleLock(ScheduleDataServiceV2.brandId, $scope.scheduleData[0].id, true)
                        .then(function () {
                            HNotifications.show({
                                title: $filter("translate")("Locked Schedule"),
                                desc: $filter("translate")("Schedule is locked, you won't be able to make any changes"),
                                icon: "fa-lock"
                            });
                            $scope.scheduleLockStatus = ScheduleDataServiceV2.lockStatus = "LOCKED";
                            $scope.$digest();

                            deferred.resolve();
                        }, function () {
                            deferred.resolve();
                        });
                } else {
                    deferred.resolve();
                }

                return deferred.promise;
            };

            //Init the controller
            var init = function () {
                loadScheduleData();
            };

            init();

        }]);

})(angular, moment, TeamScheduleAPI);
